import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router } from '@angular/router';
import { Permission } from '@bciti/types';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { MessageService } from 'src/app/global/services/message/message.abstract.service';
import { State } from 'src/app/store';
import { authPermissionsSelector } from 'src/app/auth/store/auth.selectors';

@Injectable()
export class PermissionGuard implements CanActivateChild {
    public t: any = {};

    constructor(
        private store: Store<State>,
        private router: Router,
        private messageService: MessageService,
        private translateService: TranslateService,
    ) {
        this.translateService
            .get('common.errors')
            .pipe(tap((t) => (this.t = t)))
            .subscribe();
    }

    canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
        // If no permissions are required on this route, allow immediately.
        if (!route?.data?.permissions) {
            return of(true);
        }

        return this.store.select(authPermissionsSelector).pipe(
            filter((permissions) => permissions !== undefined),
            take(1),
            map((permissions) => {
                if ((route?.data?.permissions as Permission[])?.every((p) => permissions?.includes(p))) {
                    return true;
                }
                this.router.navigate(['/']);
                this.messageService.error(this.t.notAllowed);
                return false;
            }),
        );
    }
}
